import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=2fa7afd2&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&lang=js"
export * from "./ActionButtons.vue?vue&type=script&lang=js"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=2fa7afd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7afd2",
  null
  
)

export default component.exports